var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"calc-bottom"},[_c('IconBank'),_c('span',[_vm._v(_vm._s(_vm.count))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }